import { Heading, HStack, Image, Text, VStack } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import React from "react";

const Card = ({ title, description, imageSrc }) => {
  return (
    <VStack
      backgroundColor="white"
      borderRadius="lg"
      overflow="hidden"
      alignItems="flex-start"
      spacing={0}
    >
      <Image src={imageSrc} alt={title} width="100%" objectFit="cover" />
      <VStack alignItems="flex-start" padding={4} spacing={4}>
        <Heading as="h3" size="md" color="black">
          {title}
        </Heading>
        <Text color="gray.600" fontSize="sm">
          {description}
        </Text>
        <HStack spacing={2} color="black">
          <Text fontSize="sm" fontWeight="bold">
            See more
          </Text>
          <FontAwesomeIcon icon={faArrowRight} size="1x" />
        </HStack>
      </VStack>
    </VStack>
  );
};

export default Card;
